<template>
  <div>
    <div>测试文件读取</div>
    <div v-html="content"></div>
    <a href="javascript:void(null);" @click="downloadClicked">下载</a>
  </div>
</template>

<script>
import DownloadManager from "../js/download";

export default {
  name: "MyTestPage",
  data() {
    return {
      content: null,
    }
  },

  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      const file = this.loadFile('static/shl_member_protocol.html');
      // console.log(file);
      this.content = file;
    },
    downloadClicked() {
      // if (this.isWeixin()) {
      //   this.$message({
      //     showClose: true,
      //     message: '请点击右上角，在浏览器打开后下载本视频',
      //   })
      // } else {
      //   let url = 'https://img.shslqxh.com/4399422b-b86f-4966-928a-15ba2de6557a.mp4';
      //   // let url = 'https://obs.zheshi.tech/default/video/promo.mp4';
      //
      //   DownloadManager.download(url, 'test11.mp4');
      // }
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/MyTestPage.vue